import React from 'react';
import Tittle from '../Tittle';
import p11 from '../../img/projects/one/p21.JPG'
import p12 from '../../img/projects/one/p22.JPG'
import p13 from '../../img/projects/one/p23.JPG'

const ProjectsTwo = () => {
    const two = {
        id: 2,
        title: 'Fenian Tourism',
        live: 'Live Site',
        link: 'https://serene-noyce-1e2f7d.netlify.app/',
        linkgc: 'https://github.com/alihaydararman/tourism-website-client-side',
        linkgs: 'https://github.com/alihaydararman/-tourism-website-server-side',
        git: 'GitHub(Client)',
        gits: 'GitHub(Server)',
        date: '09',
        month: 'Dec',
        year: '2019',
        details: 'Details',
        projects: '/projects2'
    }
    return (
        <div className="container">
            <div classNameName="b-title">
                <Tittle title={two.title} span={two.title} />
            </div>
            <div className='py-5'>
                <div id="carouselExampleFade" className="carousel slide carousel-fade" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <img src={p11} className="d-block w-100" alt="..." />
                        </div>
                        <div className="carousel-item">
                            <img src={p12} className="d-block w-100" alt="..." />
                        </div>
                        <div className="carousel-item">
                            <img src={p13} className="d-block w-100" alt="..." />
                        </div>
                    </div>
                    <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="prev">
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleFade" data-bs-slide="next">
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>
            </div>
            <div>
                <div className='row-12'>

                    <p>
                        <button className="btn btn-danger" style={{ width: 'fitcontent', padding: '10px', borderRadius: '5px', margin: '2px' }}><a style={{ textDecoration: 'none', color: 'white' }} href={two.link}>{two.live}</a></button>
                        <button className="btn btn-danger" style={{ width: 'fitcontent', padding: '10px', borderRadius: '5px', margin: '2px' }}><a style={{ textDecoration: 'none', color: 'white' }} href={two.linkgc}>{two.git}</a></button>
                        <button className="btn btn-danger" style={{ width: 'fitcontent', padding: '10px', borderRadius: '5px', margin: '2px' }}><a style={{ textDecoration: 'none', color: 'white' }} href={two.linkgs}>{two.gits}</a></button>
                    </p>
                    <h1>Project Name :{two.title}</h1>
                </div>
                <div className='row-12'>
                    <ul>
                        <li>It is a responsive travel agency website, from where someone can book any tour plan.</li>
                        <li>Users and Admin can sign up and log in to this website using Google. Anyone can control order, added new booking as in this project I have open it for all. So users and admin can see same dashboards.</li>
                        <li>No one can place any booking without login or sign up or sign in using Google method as it is private and implement with firebase authentication.</li>
                    </ul>
                    <p><strong>Front-end Technology: </strong>HTML5, CSS3, Bootstrap5, React.js, React-Router, JSX. </p>
                    <p><strong>Back-end Technology: </strong>Node JS, Express JS, Mongo DB, Firebase.</p>
                </div>
            </div>
        </div>
    );
};

export default ProjectsTwo;